import { ErrorState } from '../../types/AppTypes';
import { SET_ERROR } from '../actionTypes';

const initialState: ErrorState = {
  errorMessage: '',
  hasError: false,
};

export default function application(state = initialState, action: any) {
  switch (action.type) {
    case SET_ERROR: {
      return {
        ...action.payload,
      };
    }
    default:
      return state;
  }
}
